
// 加工厂
import Layout from '@/views/layout/layout'
export const yzdwRouters =
  [
    {
      path: '/yzdw',
      iconCls: 'fa el-icon-s-management', // 图标样式class
      name: '引种单位',
      component: Layout,
      meta: { role: ['YZDW'] },
      children: [
        {
          iconCls: 'el-icon-arrow-right',
          path: '/yzdw/document/apply',
          name: '调入信息申请',
          meta: { keepAlive: true, url: "/YZDW/document_apply.html" },
          component: () => import('@/views/iframe/index.vue')
        },
        {
          iconCls: 'el-icon-arrow-right',
          path: '/yzdw/document/confirm',
          name: '调入信息核销',
          meta: { keepAlive: true, url: "/YZDW/port_confirm.html" },
          component: () => import('@/views/iframe/index.vue')
        },
        {
          iconCls: 'el-icon-arrow-right',
          path: '/yzdw/approve',
          name: '审批单查询',
          meta: { keepAlive: true, url: "/YZDW/approve.html" },
          component: () => import('@/views/iframe/index.vue')
        },
        {
          iconCls: 'el-icon-arrow-right',
          path: '/YZDW/goods',
          name: '货物查询',
          meta: { keepAlive: true, url: "/YZDW/goods.html" },
          component: () => import('@/views/iframe/index.vue')
        }
      ]
    }
  ]


// WEBPACK FOOTER //
// ./src/router/yzdw.js